import request from "@/api/request"
import urls from './config'

function wthflist(data) {
    return request({
        url: urls+'api/course/rebackInfo',
        method: "get",
        data
    })
}


function addwt(data) {
    return request({
        url: urls+'api/course/addques',
        method: "post",
        data
    })
}

function wdlist(data) {
    return request({
        url: urls+'api/course/ques',
        method: "get",
        data
    })
}

function ksdetail(data) {
    return request({
        url: urls+'api/course/hourdetail',
        method: "get",
        data
    })
}

function changeks(data) {
    return request({
        url: urls+'api/course/studentrate',
        method: "get",
        data
    })
}

function getchater(data) {
    return request({
        url: urls+'api/course/chapter',
        method: "get",
        data
    })
}
function addpj(data) {
    return request({
        url: urls+'api/course/eval',
        method: "post",
        data
    })
}

function getpjlist(data) {
    return request({
        url: urls+'api/course/alleval',
        method: "get",
        data
    })
}
function getVideo(data) {
    return request({
        url: urls+'api/resource/resourcepage',
        method: "get",
        data
    })
}
function sc(data) {
    return request({
        url: urls+'api/course/collection',
        method: "get",
        data
    })
}
function qxsc(data) {
    return request({
        url: urls+'api/course/cancelcollection',
        method: "get",
        data
    })
}
function getdetail(data) {
    return request({
        url: urls+'api/course/detail',
        method: "get",
        data
    })
}
function getlessionlist(data) {
    return request({
        url: urls+'api/course/recommend',
        method: "get",
        data
    })
}
function getlession(data) {
    return request({
        url: urls+'api/course/homepage',
        method: "get",
        data
    })
}
function getClass(data) {
    return request({
        url: urls+'api/class/classlist',
        method: "get",
        data
    })
}
function getTree(data) {
    return request({
        url:urls+ 'api/resource/getmodels',
        method: "get",
        data
    })
}
function detail(data) {
    return request({
        url:urls+ 'api/resource/detail',
        method: "get",
        data
    })
}
function SetStore(data) {
    return request({
        url:urls+'api/store/SetStore',
        method: "get",
        data
    })
}
function excel(data) {
    return request({
        url:urls+ 'api/PreView/excel',
        method: "get",
        data
    })
}
function word(data) {
    return request({
        url:urls+ 'api/PreView/word',
        method: "get",
        data
    })
}
function ppt(data) {
    return request({
        url:urls+ 'api/PreView/ppt',
        method: "get",
        data
    })
}
function pdf(data) {
    return request({
        url:urls+ 'api/PreView/pdfimage',
        method: "get",
        data
    })
}

export default{
    getVideo,
    getClass,
    getTree,
    detail,
    SetStore,
    excel,
    word,
    ppt,
    pdf,
    getlession,
    getlessionlist,
    getdetail,
    getpjlist,
    getchater,
    changeks,
    ksdetail,
    wdlist,
    addwt,
    wthflist,
    addpj,
    sc,
    qxsc
}